import rechercheUI from './rechercheUI';

export class magasinsUI extends rechercheUI {
    constructor(opts) {
        super(opts); //don't forget "super"
    }
    getFavoris() {
        let favorites = [];
        let dropdownMagasins = [...document.querySelectorAll('.list-magasins .magasin-infos')];
        let fallbackMagId = [...document.querySelectorAll('.fallback-magasin-id')];

        if (dropdownMagasins.length > 0) {
            // a partir de ce moment la on sait si le user est connecté

            for (let index = 0; index < dropdownMagasins.length; index++) {
                const dropdownMagasin = dropdownMagasins[index];
                let magIdEl = dropdownMagasin.querySelector('[data-magasin-id]');

                let mag = this.getMagasin(magIdEl.getAttribute('data-magasin-id'))

                favorites.push(mag);

            }
        } else {
            for (let index = 0; index < fallbackMagId.length; index++) {
                const MagId = fallbackMagId[index];

                let mag = this.getMagasin(MagId.getAttribute('data-magasin-id'))

                favorites.push(mag);

            }
        }
        return favorites;
    }
    makeInitProcess() {
        var that = this;
        that.setInformationsFromStorage();

        let magsAfterStorage = that.getSelectedMagasin();
        let favorites = that.getFavoris();

        that.loadMap('0');
        if (magsAfterStorage.length > 0) {

            that.addInSelection(magsAfterStorage[0]);
        }
        if (favorites.length > 0) {
            for (let index = 0; index < favorites.length; index++) {
                const favorite = favorites[index];
                that.addInSelection(favorite)
            }
        }

        let allMags = that.getSelectedMagasin();
        if (allMags.length > 0) {
            let bounds = that.getBounds(allMags);
            that.map.fitBounds(bounds);
        }

        that.registerListeners();

        that.hooks.ready(that);
    }
    makeInitRequest(save = false) {
        var that = this;
        this.makeRequest({
            credentials: true,
            method: 'GET',
            url: this.options.url,
            async: true,
            cache: false,
            dataType: 'json',
            header: {
                'Access-Control-Allow-Origin': '*',
                'X-CSRF-TOKEN': this.options.token
            },
            data: {}
        }, function (err, datas) {

            if (err) {
                //console.log('error', datas)
                return false;
            }

            if(save) {
                let dateAjax = new Date();
                localStorage.setItem('ajaxMagDate', dateAjax.getTime())
                localStorage.setItem('ajaxMagResponse', JSON.stringify([ datas ]))
            }

            var resp = JSON.parse(datas);

            //console.log('resp', resp)

            that.options.store.datas = resp;
            that.makeInitProcess();

        })
    }
    init() {
        this.hooks.init(this);

        var that = this;

        // fix temporaire
        if (this.options.file && this.options.file.length > 0 && this.options.ajax === false) {
            this.options.store.datas = this.options.file
            this.makeInitProcess()

        } else {

            let dateAjaxCheck = localStorage.getItem('ajaxMagDate');
            console.log('dateAjaxCheck', dateAjaxCheck)

            if(dateAjaxCheck != null) {
                // console.log('a')
                // Une requete est deja passée et sauvée
                let diff = this.diff_hours( new Date( Number(dateAjaxCheck) ) , new Date() );
                // console.log('diff', diff)
                if( diff  >= this.options.refreshMagasins ) {
                    // console.log('b')
                    this.makeInitRequest(true);
                }
                else {
                    // console.log('c')
                    // pas besoin de faire de request
                    let one = JSON.parse( localStorage.getItem('ajaxMagResponse') );
                    // console.log( JSON.parse( one[0] ) )
                    this.options.store.datas = JSON.parse( one[0] );
                    this.makeInitProcess()
                }
            }
            else {
                // console.log('d')
                this.makeInitRequest(true);
            }


        }
    }
    makeUrl() {
        let url = route('page').template;
        let locationSplit = window.location.pathname.split('/');
        url = url.replace('{lang}', Lang.locale)
            .replace('{slug?}', locationSplit[locationSplit.length - 1])

        return url;
    }
    registerListeners() {}
}
